import { useEffect, useState } from 'react';
import { FiWifiOff } from 'react-icons/fi';

// App-wide "no connection" bar. Shows when the device goes offline so no screen
// ever just silently fails or sits blank on a flaky network — the kind of thing
// an App Store reviewer (who tests on throttled / IPv6 connections) checks for
// under Guideline 4.2. Pinned under the status bar via the top safe-area.
//
// navigator.onLine is the simple, widely-supported signal: false reliably means
// offline. Actual request failures (server slow/unreachable while "online") are
// handled per-screen with retry states; this covers the hard-offline case.
export default function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' && navigator.onLine === false,
  );

  useEffect(() => {
    const goOnline = () => setOffline(false);
    const goOffline = () => setOffline(true);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[150] flex items-center justify-center gap-2 bg-ink px-4 pb-2 pt-[calc(env(safe-area-inset-top,0px)+0.5rem)] text-center text-sm font-medium text-cream-50"
    >
      <FiWifiOff className="h-4 w-4" aria-hidden="true" />
      <span>Fără conexiune la internet</span>
    </div>
  );
}
